"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackOutlined = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.FeedbackOutlined = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M21.625 13.875H10.375V11.875H21.625V13.875Z" }),
            react_1.default.createElement("path", { d: "M10.375 17.25H21.625V15.25H10.375V17.25Z" }),
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M27.25 21.875V7.25H4.75V21.875H10.375L10.375 25.25L16 21.875L27.25 21.875ZM12.375 21.7176L15.446 19.875L25.25 19.875V9.25L6.75 9.25L6.75 19.875H12.375V21.7176Z", fillRule: "evenodd" }))),
        size === 'medium' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M16.5 10.2502H7.5V8.75018H16.5V10.2502Z" }),
            react_1.default.createElement("path", { d: "M7.5 12.9504H16.5V11.4504H7.5V12.9504Z" }),
            react_1.default.createElement("path", { clipRule: "evenodd", d: "M21 16.7002V5.00018H3V16.7002H7.5V19.4002L12 16.7002L21 16.7002ZM9 16.7509L11.5845 15.2002L19.5 15.2002V6.50018L4.5 6.50018L4.5 15.2002H9V16.7509Z", fillRule: "evenodd" })))));
});
exports.FeedbackOutlined.displayName = 'FeedbackOutlined';
//# sourceMappingURL=FeedbackOutlined.js.map